import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useSubmitApplication = (url) => {
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const submit = async (data) => {
        setIsLoading(true);
        data.lang = i18n.language || 'en'; // default language to english
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            const message = t('errorMsgSubmit');
            setIsLoading(false);
            setError({ message });
            return response;
        }
        const d = await response.json();
        setIsLoading(false);
        return d;
    };

    return [submit, isLoading, error];
};

export default useSubmitApplication;
